import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';
import IComponentsConfig from '../../vendor_core/core/src/managers/contracts/configurations/IComponentsConfig';

class ComponentsConfig implements IComponentsConfig {

    type: ConfigurationTypes = ConfigurationTypes.COMPONENTS;
    sliders = [
        {
            id: "single_win_limit",
            frameOffset: 3
        },
        {
            id: "win_limit_slider",
            frameOffset: 3
        },
        {
            id: "loss_limit_slider",
            frameOffset: 3
        }  
    ]

}

export default new ComponentsConfig();